import Link from 'next/link';
import { useRouter, withRouter } from 'next/router';
import React, { Children } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../../theme';
import { Box, CenterCol, Column } from '../../Flex';
import Settings from '../../svgs/Settings';

const ActiveLink = ({ children, query, href, ...rest }) => {
  const router = useRouter();
  return (
    <Link {...rest} href={href} legacyBehavior>
      {React.cloneElement(Children.only(children), {
        className:
          router.asPath === href || router.pathname.split('/')[2] === query
            ? `active`
            : null,
      })}
    </Link>
  );
};

const Container = styled(Column)`
  padding-right: 50px;
  background-color: #fff;
  width: 140px;
  position: sticky;
  top: 10px;
  flex-basis: 40px;
  align-self: start;
  @media only screen and (max-width: 800px) {
    width: 100%;
    padding-right: 0;
    z-index: 100;
    top: 0;
    padding: 16px 0;
    height: 70px;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const LinkIcon = styled(CenterCol)`
  min-width: 40px;
  min-height: 40px;
  border-radius: 6px;
  background: #b3becf22;
  cursor: pointer;
  svg {
    fill: #b3becf;
  }
  &.active {
    background: ${COLORS.ACCENT}22;
    svg {
      fill: ${COLORS.ACCENT};
    }
  }
`;

const Nav = () => {
  return (
    <Container className="mt-0 md:mt-20">
      <ActiveLink href="/dashboard" query="">
        <LinkIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17.945"
            height="17.945"
            viewBox="0 0 17.945 17.945"
          >
            <path d="M6.916,0H1.308A1.31,1.31,0,0,0,0,1.308V4.673A1.31,1.31,0,0,0,1.308,5.982H6.916A1.31,1.31,0,0,0,8.225,4.673V1.308A1.31,1.31,0,0,0,6.916,0Zm0,0" />
            <path
              d="M6.916,213.332H1.308A1.31,1.31,0,0,0,0,214.641v7.851A1.31,1.31,0,0,0,1.308,223.8H6.916a1.31,1.31,0,0,0,1.309-1.308v-7.851A1.31,1.31,0,0,0,6.916,213.332Zm0,0"
              transform="translate(0 -205.855)"
            />
            <path
              d="M284.248,341.332h-5.608a1.31,1.31,0,0,0-1.309,1.309v3.365a1.31,1.31,0,0,0,1.309,1.308h5.608a1.31,1.31,0,0,0,1.308-1.308v-3.365A1.31,1.31,0,0,0,284.248,341.332Zm0,0"
              transform="translate(-267.612 -329.369)"
            />
            <path
              d="M284.248,0h-5.608a1.31,1.31,0,0,0-1.309,1.308V9.159a1.31,1.31,0,0,0,1.309,1.309h5.608a1.31,1.31,0,0,0,1.308-1.309V1.308A1.31,1.31,0,0,0,284.248,0Zm0,0"
              transform="translate(-267.612)"
            />
          </svg>
        </LinkIcon>
      </ActiveLink>
      <Box height={30} width={30} />
      <ActiveLink href="/dashboard/settings" query="settings">
        <LinkIcon>
          <Settings color="" />
        </LinkIcon>
      </ActiveLink>
      {/* <ActiveLink href="/dashboard/profile" query="profile">
        <LinkIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.082"
            height="21.082"
            viewBox="0 0 21.082 21.082"
          >
            <g>
              <path d="M10.541,0A10.541,10.541,0,1,0,21.082,10.542,10.541,10.541,0,0,0,10.541,0Zm0,3.152A3.487,3.487,0,1,1,7.055,6.639,3.487,3.487,0,0,1,10.541,3.153Zm0,15.174A7.736,7.736,0,0,1,5.5,16.469,1.486,1.486,0,0,1,4.98,15.34a3.516,3.516,0,0,1,3.533-3.515H12.57A3.511,3.511,0,0,1,16.1,15.34a1.482,1.482,0,0,1-.521,1.129A7.734,7.734,0,0,1,10.539,18.327Z" />
            </g>
          </svg>
        </LinkIcon>
      </ActiveLink> */}
      {/* <Box height={30} width={30} />
      <ActiveLink href="/dashboard/transactions/purchases" query="transactions">
        <LinkIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
          >
            <path
              d="M523-3394H508a2,2,0,0,1-2-2v-15a2,2,0,0,1,2-2h15a2,2,0,0,1,2,2v15A2,2,0,0,1,523-3394Zm-3.334-10.556a1,1,0,0,0-1,1v4.333a1,1,0,0,0,1,1h.111a1,1,0,0,0,1-1v-4.333a1,1,0,0,0-1-1Zm-4.222-4.222a1,1,0,0,0-1,1v8.555a1,1,0,0,0,1,1h.111a1,1,0,0,0,1-1v-8.555a1,1,0,0,0-1-1Zm-4.223,4.222a1,1,0,0,0-1,1v4.333a1,1,0,0,0,1,1h.112a1,1,0,0,0,1-1v-4.333a1,1,0,0,0-1-1Z"
              transform="translate(-506 3413)"
            />
          </svg>
        </LinkIcon>
      </ActiveLink>
      <Box height={30} width={30} />
      <ActiveLink href="/dashboard/settings" query="settings">
        <LinkIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.509"
            height="19.345"
            viewBox="0 0 14.509 19.345"
          >
            <g transform="translate(-64)">
              <g transform="translate(64)">
                <path
                  d="M78.106,7.254H76.9V5.642a5.642,5.642,0,1,0-11.285,0V7.254H64.4a.4.4,0,0,0-.4.4V17.733a1.614,1.614,0,0,0,1.612,1.612H76.9a1.614,1.614,0,0,0,1.612-1.612V7.657A.4.4,0,0,0,78.106,7.254Zm-5.645,8.419a.4.4,0,0,1-.4.448H70.448a.4.4,0,0,1-.4-.448l.254-2.286a1.594,1.594,0,0,1-.66-1.3,1.612,1.612,0,1,1,3.224,0,1.594,1.594,0,0,1-.66,1.3Zm2.017-8.419H68.03V5.642a3.224,3.224,0,1,1,6.448,0Z"
                  transform="translate(-64)"
                />
              </g>
            </g>
          </svg>
        </LinkIcon>
      </ActiveLink> */}
    </Container>
  );
};

export default withRouter(Nav);
